import { useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function Messages() {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const [body, setBody] = useState("");
  const endRef = useRef(null);

  const load = () => api.get("/messages").then(r => setMsgs(r.data));

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    try {
      await api.post("/messages", { body });
      setBody("");
      load();
    } catch { toast.error("Send failed."); }
  };

  return (
    <div data-testid="messages-page" className="max-w-3xl mx-auto px-6 sm:px-10 py-16">
      <div className="eyebrow-lg text-center">Direct Line</div>
      <h1 className="mt-8 h-editorial text-5xl text-center">Between <span className="italic-serif text-[#D4AF37]">us.</span></h1>
      <p className="mt-4 text-center text-sm text-zinc-400">Private messaging with Rebel — before and after we meet.</p>

      <div className="mt-10 hairline min-h-[50vh] flex flex-col">
        <div className="flex-1 p-6 space-y-4 overflow-y-auto">
          {msgs.length === 0 && <div className="text-center text-zinc-500 text-sm py-20">Say the first thing.</div>}
          {msgs.map(m => (
            <div key={m.message_id} data-testid={`msg-${m.message_id}`} className={`max-w-[80%] p-4 ${m.author_id === user?.user_id ? "ml-auto bg-[#0052FF]/15 border border-[#0052FF]/40" : "border border-white/10"}`}>
              <div className="eyebrow mb-2">{m.author_role === "admin" ? "Rebel" : m.author_name}</div>
              <div className="text-sm text-zinc-100 whitespace-pre-wrap">{m.body}</div>
              <div className="mt-2 text-[10px] text-zinc-500 font-mono-eyebrow uppercase tracking-[0.18em]">{new Date(m.created_at).toLocaleString()}</div>
            </div>
          ))}
          <div ref={endRef} />
        </div>
        <form onSubmit={send} className="hairline-t p-4 flex gap-2">
          <input data-testid="message-input" value={body} onChange={e => setBody(e.target.value)} className="flex-1 px-4 py-3" placeholder="Write privately…" />
          <button data-testid="message-send" type="submit" className="rc-btn-primary inline-flex items-center gap-2"><Send className="w-3.5 h-3.5" /> Send</button>
        </form>
      </div>
    </div>
  );
}
